import React from "react";
import Question from '../components/Question'
import VehicleTitle from '../components/VehicleTitle'
import { Form } from 'react-bootstrap'
import { connect } from "react-redux";
import { IAppState } from "../state/interfaces";
import { QUOTE_STEPS, YES_NO, COMPONENTS, QUOTE_QUESTIONS } from "../AppConstants";
import { IVehicleStepProps, IQuoteStepState } from "../components/interfaces";
import QuoteStep from "./QuoteStepLayout";
import Utilities from "../classes/Utilities";
import { validationUtils } from "../validation/Validation";
import ButtonContinue from "../components/ButtonContinue";
import ComplexCheckbox from "../components/ComplexCheckbox";
import QuoteStepBase from '../components/QuoteStepBase'
import { IQuoteApiClient, IPaths } from "../classes/Domain";
import QuoteActions from "../state/appActions";


const QUESTIONS = {
    USE_YEARS: {
        LESS_THAN_YEAR: "< 1",
        ONE_YEAR: "1",
        TWO_YEARS: "2",
        THREE_YEARS: "3",
    }
}

//interface VehicleDetailsProps extends IVehicleStepProps {
    
//}

interface IState extends IQuoteStepState {
    ownership : string,
    payments: string | null,
    useYears: string,
    updatingStore : boolean,
    antiTheftOnStar : boolean,
    antiTheftVehicleRecoveryDevice : boolean,
    antiTheftAutomaticDisabling: boolean,
    validated: boolean;
}

export interface IProps extends IVehicleStepProps {
    quoteApiClient: IQuoteApiClient,
    PATHS: IPaths;
}

class VehicleDetails extends QuoteStepBase<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.next = this.next.bind(this);
        this.handleAntiTheftOnStarChange = this.handleAntiTheftOnStarChange.bind(this);
        this.handleAntiTheftRecoveryDeviceChange = this.handleAntiTheftRecoveryDeviceChange.bind(this);
        this.handleAntiTheftAutomaticDisablingChange = this.handleAntiTheftAutomaticDisablingChange.bind(this);

        this.state = {
            ownership: "",
            payments: "",
            useYears: "",
            updatingStore : false,
            antiTheftOnStar : false,
            antiTheftVehicleRecoveryDevice : false,
            antiTheftAutomaticDisabling: false,
            validated: false,
            errors: []
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    componentWillUnmount() {
        validationUtils.unsubscribeFromValidationFailure("VehicleDetails");
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const vehicle = nextProps.vehicle;
           
            const nextState = {
                ...prevState,
                ownership: vehicle.ownership,
                payments: vehicle.payments,
                useYears: vehicle.useYears,
                antiTheftOnStar: vehicle.antiTheftOnStar,
                antiTheftVehicleRecoveryDevice: vehicle.antiTheftVehicleRecoveryDevice,
                antiTheftAutomaticDisabling: vehicle.antiTheftAutomaticDisabling
            };
            
            nextProps.meta.propsSource = "";
            return nextState;
        }

        return prevState;
    }

    next(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault();

        this.setState({ updatingStore: true }, () => {
            const updatedVehicle = {
                ...this.props.vehicle,
                ownership: this.state.ownership,
                payments: this.state.payments,
                useYears: this.state.useYears,
                antiTheftOnStar: this.state.antiTheftOnStar,
                antiTheftVehicleRecoveryDevice: this.state.antiTheftVehicleRecoveryDevice,
                antiTheftAutomaticDisabling: this.state.antiTheftAutomaticDisabling
            };

            this.props.updateAppState({ quoteUid: this.props.quoteUid, vehicle: updatedVehicle })
                .then(() => this.props.history.push(Utilities.formatUrl(this.props.PATHS.HOW_YOU_DRIVE, (0 < this.props.vehicleIndex ? this.props.vehicleIndex + "" : ""))),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    }
            );
        });
    }

    ownershipCallbackFunction = (childData: string) => {
        if (childData === QUOTE_QUESTIONS.VEHICLE_DETAILS.OWNERSHIP.LEASE) {
            this.setState({ ...this.state, ownership: childData, payments: null });
        } else {
            this.setState({ ...this.state, ownership: childData });
        }
    };

    paymentsCallbackFunction = (childData: string) => {
        this.setState({ ...this.state, payments: childData });
    };

    useYearsCallbackFunction = (childData: string) => {
        this.setState({ ...this.state, useYears: childData });
    };

    handleAntiTheftOnStarChange(evt: any) {
        this.setState({ ...this.state, antiTheftOnStar: !this.state.antiTheftOnStar });
    }

    handleAntiTheftRecoveryDeviceChange(evt: any) {
        this.setState({ ...this.state, antiTheftVehicleRecoveryDevice: !this.state.antiTheftVehicleRecoveryDevice });
    }

    handleAntiTheftAutomaticDisablingChange(evt: any) {
        this.setState({ ...this.state, antiTheftAutomaticDisabling: !this.state.antiTheftAutomaticDisabling });
    }

    render() { 
        return (
            <QuoteStep id={this.props.id}>
                <div className="titleArea"><VehicleTitle vehicle={this.props.vehicle} /></div>
                <Form noValidate validated={null != this.state.errors} className={null != this.state.errors ? "is-invalid" : ""}>
                    <Question
                        name="ownership"
                        error={validationUtils.hasValidationErrorFor(this.state.errors, "ownership") ? this.state.errors["ownership"][0] : ""}
                        selected={this.ownershipCallbackFunction}
                        selectedValue={this.state.ownership}
                        items={[QUOTE_QUESTIONS.VEHICLE_DETAILS.OWNERSHIP.OWN, QUOTE_QUESTIONS.VEHICLE_DETAILS.OWNERSHIP.LEASE]}
                        lable="Do you own or lease this car?" />

                    <Question
                        name="payments"
                        error={validationUtils.hasValidationErrorFor(this.state.errors, "payments") ? this.state.errors["payments"][0] : ""}
                        selected={this.paymentsCallbackFunction}
                        selectedValue={this.state.payments}
                        style={{ display: this.state.ownership === QUOTE_QUESTIONS.VEHICLE_DETAILS.OWNERSHIP.OWN ? '' : 'none' }}
                        items={[YES_NO.YES, YES_NO.NO]}
                        lable="Do you currently make payments on this car?" />

                    {
                        //<Question
                        //    name="useYears"
                        //    error={validationUtils.hasValidationErrorFor(this.state.errors, "useYears") ? this.state.errors["useYears"][0] : ""}
                        //    selected={this.useYearsCallbackFunction}
                        //    selectedValue={this.state.useYears}
                        //    items={[QUESTIONS.USE_YEARS.LESS_THAN_YEAR, QUESTIONS.USE_YEARS.ONE_YEAR, QUESTIONS.USE_YEARS.TWO_YEARS, QUESTIONS.USE_YEARS.THREE_YEARS]}
                        //    lable="How many years have you had this car?" />
                    }

                    {/*<Form.Label>Does your car have any anti-theft features? Select any that apply.</Form.Label>*/}
                    {
                        //<ComplexCheckbox
                        //    children={
                        //        <div>
                        //            <Form.Check.Label>OnStar</Form.Check.Label>
                        //            <p>Subscription service that uses GPS and other anti-theft technologies to recover your car if stolen or in case of an accident or breakdown.</p>
                        //        </div>
                        //    }
                        //    value={this.state.antiTheftOnStar}
                        //    onChange={this.handleAntiTheftOnStarChange} />

                        //<ComplexCheckbox
                        //    children={
                        //        <div>
                        //            <Form.Check.Label>Vehicle Recovery Device</Form.Check.Label>
                        //            <p>Uses GPS to find your vehicle if stolen. Also known as a "tracker".</p>
                        //        </div>
                        //    }
                        //    value={this.state.antiTheftVehicleRecoveryDevice}
                        //    onChange={this.handleAntiTheftRecoveryDeviceChange} />

                        //<ComplexCheckbox
                        //    children={
                        //        <div>
                        //            <Form.Check.Label>Automatic Disabling</Form.Check.Label>
                        //            <p>Disables the vehicle by making the fuel, ignition, or starting system inoperatives</p>
                        //        </div>
                        //    }
                        //    value={this.state.antiTheftAutomaticDisabling}
                        //    onChange={this.handleAntiTheftAutomaticDisablingChange} />
                    }

                </Form>
                <div className="btnContainer">
                    <Form.Label>By clicking “Continue”, you confirm that you agree to our Privacy Policy and Terms & Conditions</Form.Label>
                    <ButtonContinue
                        disabled={this.state.updatingStore}
                        showLoading={this.state.updatingStore}
                        onClick={this.next} />
                </div>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IVehicleStepProps) => {
    var vehicleIndex = !ownProps.match.params["vehicleIndex"]
        ? 0
        : parseInt(ownProps.match.params["vehicleIndex"], 10);

    return {
        quoteUid: state.quoteUid,
        vehicleIndex: vehicleIndex,
        vehicle: vehicleIndex < state.vehicles.length ? state.vehicles[vehicleIndex] : null,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE },
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(QUOTE_STEPS.VEHICLE_DETAILS)),
        updateAppState: (update) => dispatch(quoteActions.updateVehicle(update.quoteUid, update.vehicle, QUOTE_STEPS.VEHICLE_DETAILS))
    };
};

export default connect(mapProps, mapDispatch)(VehicleDetails);